<template>
	<div class="course_bottomRight">
		<div class="course_title">课程详情</div>
		<div class="course_tabInfoText clearfix">
			<img src="@/images/course_tabInfoText.png" />
			<div class="course_tabInfoMain">
				{{course.info || '暂无'}}
			</div>
		</div>
		<div class="course_title">参考资料</div>
		<div class="course_tabInfoNormal">
			{{course.references || '暂无'}}
		</div>
		<div class="course_title">课程概述</div>
		<div class="course_tabInfoNormal">
			<div v-html="course.overview" v-if="course.overview"></div>
			<span v-else>暂无课程概述</span>
		</div>
	</div>
</template>

<script>
	import { appCourseTree } from '@/api/course.js'
	export default {
		props: {
			courseId: String,
		},
		data() {
			return {
				course: {},
			}
		},
		created() {
			this.getCourseinfo();
		},
		mounted() {

		},
		methods: {
			getCourseinfo() {
				var data = {
					courseId: this.courseId
				}
				appCourseTree(data).then(res => {
					if(res.code == "OK") {
						this.course = res.data;
					}
				})
			},
		},
	}
</script>